// extracted by mini-css-extract-plugin
var _1 = "qt5fj";
var _2 = "nzDk3";
var _3 = "Cdl7O";
var _4 = "gYwj4";
var _5 = "qBfw8";
var _6 = "D0Alk";
var _7 = "JYu8Z";
var _8 = "vCcoC";
export { _1 as "base", _2 as "identifier", _3 as "level-error", _4 as "level-success", _5 as "level-warning", _6 as "link", _7 as "parameter", _8 as "tag" }
